import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../loader.service';
import { NgxSpinnerService } from 'ngx-spinner'
import { UserInfoService } from '../_services/userInfo.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    constructor(public loaderService: LoaderService, private spinner: NgxSpinnerService, readonly userInfoService: UserInfoService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!(request.url.includes('recent') || request.url.includes('statuses') || request.url.includes('count'))) {
            this.spinner.show();
        }
        const isApiUrl = request.url.startsWith(environment.API_BASE_PATH);
        const isXtenantId = request.headers.get('X-Tenant-ID');
        const lang = (this.checkValidation('lang') ? localStorage.getItem('lang') : 'en') || 'en';
        const tenantID = !!this.userInfoService.userDetails && !!this.userInfoService.userDetails.tenantID ? this.userInfoService.userDetails.tenantID : 'TELIOEV';
        if (isApiUrl && (!request.url.includes('landing-page') && !request.url.includes('tenant')) && !isXtenantId) {
            request = request.clone({
                headers: request.headers.set('Accept-Language', lang)
                    .set('X-Tenant-ID', tenantID)
            });
        } else if (!request.url.includes('menu') && (request.url.includes('landing-page') || request.url.includes('tenant'))) {
            request = request.clone({
                headers: request.headers.set('Accept-Language', lang)
            });
        }

        return next.handle(request).pipe(finalize(() => {
            this.spinner.hide();
        }));
    }

    checkValidation(key: string) {
        return !!localStorage.getItem(key) && localStorage.getItem(key) !== 'null' && localStorage.getItem(key) !== 'undefined';
    }
}